/**
 * מזהי משתמש ב-Clerk מגיעים בפורמט `user_<opaque>` (user_ prefix).
 * ב-Funner ה-Udid ב-DB נשמר בלי הקידומת — רק המחרוזת האטומה.
 * שימוש: נרמול בכל הזנת/השוואת Udid מה-API, כדי שיתאים ליוזרים הישנים בלי `user_`.
 */
export function stripClerkUserIdPrefix(id: string | null | undefined): string | null {
  if (id == null) return null;
  const t = id.trim();
  if (!t) return null;
  if (t.startsWith('user_')) {
    const rest = t.slice(5);
    return rest || null;
  }
  return t;
}

export function udidKey(id: string | null | undefined): string {
  return stripClerkUserIdPrefix(id) ?? '';
}
